module.exports = __webpack_public_path__ + "static/social-proof-orange-76aee82ac209f5d4b2abbdc2384537bf.jpg";